import { render, staticRenderFns } from "./Block5.vue?vue&type=template&id=2df5707f&scoped=true&"
import script from "./Block5.vue?vue&type=script&lang=js&"
export * from "./Block5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5707f",
  null
  
)

export default component.exports